import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "CasinoCompletedRacesWidget" */ './CasinoCompletedRacesWidget'),
  modules: ['./CasinoCompletedRacesWidget'],
  loading: () => null
});

export default LoadableWidget;
